/**
 * @desc supplierPageList
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(params: API.ucenter.userFacadeImpl.supplierPageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/user/supplierPageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
